export default "__VITE_ASSET__BZmu3Q3A__"